import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { SharedService } from '../../home/shared.service';
import { AlertService } from '../../util/alert/alert.service';
import { CoreCompetencyTagService } from './corecompetencytag.service';
import { UserService } from '../../user/user.service';
import { NoWhitespaceDirective } from "../../util/validator/nowhitespace.directive"
import { SanitizationService } from '../../sanitizer.service';
@Component({
	selector: 'app-edit-corecompetencytag',
	templateUrl: './editcorecompetencytag.component.html'
})

export class EditCoreCompetencyTagComponent implements OnInit {
	editCoreCompetencyTag: FormGroup;
	constructor(private router: Router,
		private sharedService: SharedService,
		private alertServices: AlertService,
		private coreCompetencyTagService: CoreCompetencyTagService,
		private userService: UserService,
		private sanitizer: SanitizationService
	) {
		if (!userService.isValidLoggedIn()) {
			userService.redirectToLoginScreen();
		}
	}
	ngOnInit() {
		this.editCoreCompetencyTag = new FormGroup({
			id: new FormControl(this.coreCompetencyTagService.curCoreCompId, Validators.required),
			coreCompetencyTag: new FormControl(this.coreCompetencyTagService.curCoreCompetency, Validators.required)
		});
	}

	selectedComponentItem(itemName: string) {
		this.sharedService.change(itemName);
	}

	onSubmit() {
		if (this.checkNeedToUpdateCoreComp()) {
			this.coreCompetencyTagService.editCoreCompetencyTag(this.editCoreCompetencyTag.value.id, this.sanitizer.sanitize(this.editCoreCompetencyTag.value.coreCompetencyTag))
				.subscribe(
				data => {
					this.alertServices.clear();
					this.alertServices.success("Successfully modified the core competency tag.");
					this.coreCompetencyTagService.curCoreCompetency = this.editCoreCompetencyTag.value.coreCompetencyTag;
				},
				error => {
					this.alertServices.clear();
					let err = error.json();
					this.alertServices.handleError(err);
				}
				);
		} else {
			this.alertServices.clear();
			this.alertServices.error('There are no changes to update.');
		}
	}

	checkNeedToUpdateCoreComp() {
		if (this.coreCompetencyTagService.curCoreCompetency != this.editCoreCompetencyTag.value.coreCompetencyTag) {
			return true;
		} else {
			return false;
		}
	}
}